module.exports = __webpack_public_path__ + "static/media/pmt_enter-payments-adjustments.10b6b438.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/pmt_enter-payments-adjustments.md
// module id = 1105
// module chunks = 0